
// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import Logo from '../assets/img/logo.png';

// const Header: React.FC = () => {
//   const [activeTab, setActiveTab] = useState<string>('Home');

//   const navItems = ['Home', 'About Us', 'Products', 'Services', 'Contact'];

//   return (
//     <header className="w-full bg-white shadow-md">
//       <div className="flex justify-between items-center p-2">
//         {/* Company Name */}
//         <div className="flex flex-md:row ml-14">
//           <img src={Logo} alt="logo" className="w-18 h-16" />
//           <div className="text-2xl text-black ml-0">
//             <span className="mr-36 underline text-black text-2xl">Adins International</span> <br />
//             <span className="text-gray-600 text-xl font-serif">One Stop Solutions for Bags & Printing</span>
//           </div>
//         </div>

//         {/* Navigation */}
//         <nav className="space-x-8 mr-60">
//           {navItems.map((item) => (
//             <div key={item} className="relative inline-block">
//               <Link
//                 to={`/${item.replace(' ', '').toLowerCase()}`} // Adjust path based on the tab name
//                 onClick={() => setActiveTab(item)}
//                 className={`cursor-pointer text-lg ${activeTab === item ? 'text-[#f98715] font-bold' : 'text-gray-600'}`}
//               >
//                 {item}
//               </Link>
//               {/* Orange bar that appears when active */}
//               {activeTab === item && (
//                 <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#f98715] transition-all ease-in-out duration-300"></div>
//               )}
//             </div>
//           ))}
//         </nav>
//       </div>
//     </header>
//   );
// };

// export default Header;


import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/img/logo.png';

const Header: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('Home');
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const navItems = ['Home', 'About Us', 'Products', 'Services', 'Contact'];

  const handleMenuToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleNavClick = (item: string) => {
    setActiveTab(item);
    setIsMenuOpen(false); // Close the menu when a nav item is clicked
  };

  return (
    <header className="w-full bg-white shadow-md">
      <div className="flex justify-between items-center p-1 lg:p-2">
        {/* Company Name */}
        <div className="flex flex-row lg:ml-14">
          <img src={Logo} alt="logo" className="w-18 h-16" />
          <div className="text-2xl text-black lg:ml-0 hidden sm:block">
            <span className="lg:mr-36 underline text-black text-2xl">Adins International</span> <br />
            <span className="text-gray-600 text-xl font-serif">One-Stop Herbal Pet Care Partner</span>
          </div>

          {/* Mobile View Text */}
          <div className="text-left sm:hidden">
            <span className="text-black text-lg">Adins International</span><br />
            <span className="text-gray-500 text-sm">One-Stop Herbal Pet Care Partner</span>
          </div>
        </div>

        {/* Desktop and Tablet Navbar */}
        <div className="hidden md:flex space-x-8 mr-60">
          {navItems.map((item) => (
            <div key={item} className="relative inline-block">
              <Link
                to={`/${item.replace(' ', '').toLowerCase()}`} // Adjust path based on the tab name
                onClick={() => handleNavClick(item)} // Update active tab and close menu
                className={`cursor-pointer text-lg ${activeTab === item ? 'text-[#f98715] font-bold' : 'text-gray-600'}`}
              >
                {item}
              </Link>
              {/* Orange bar that appears when active */}
              {activeTab === item && (
                <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#f98715] transition-all ease-in-out duration-300"></div>
              )}
            </div>
          ))}
        </div>

        {/* Mobile View Hamburger Icon */}
        <div className="md:hidden flex items-center space-x-4">
          <button onClick={handleMenuToggle} className="text-gray-600">
            {isMenuOpen ? (
              <span className="text-2xl">&#10005;</span> // Cross icon
            ) : (
              <span className="text-2xl">&#9776;</span> // Hamburger icon
            )}
          </button>
        </div>
      </div>

      {/* Mobile Drawer (Side Menu) */}
      {isMenuOpen && (
        <div className="fixed top-0 left-0 w-64 h-full bg-white shadow-md z-50">
          <div className="flex flex-col p-5">
            {navItems.map((item) => (
              <Link
                key={item}
                to={`/${item.replace(' ', '').toLowerCase()}`}
                onClick={() => handleNavClick(item)} // Close menu and set active tab
                className={`py-2 text-lg ${activeTab === item ? 'text-[#f98715] font-bold' : 'text-gray-600'}`}
              >
                {item}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
